module.exports = __webpack_public_path__ + "img/paypal.e0d99274.png";